/**
 * SectorTemperature — Strategy Insights section 2.
 * Accept/reject ratios per sector over the last 7 days.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { DS_COLORS, DS_SPACING, DS_TYPOGRAPHY } from '@/config/ui-invariants';
import { copy } from '@/content/copy';
import { SectionRegenWrap } from '@/components/strategy-insights/SectionRegenWrap';

function TemperatureBar({ accepts, rejects }) {
  const total = accepts + rejects || 1;
  const acceptPct = Math.round((accepts / total) * 100);
  return (
    <div
      style={{
        display: 'flex',
        height: 8,
        borderRadius: 4,
        overflow: 'hidden',
        background: DS_COLORS.border.default,
      }}
    >
      <div style={{ width: `${acceptPct}%`, background: DS_COLORS.text.success }} />
      <div style={{ width: `${100 - acceptPct}%`, background: DS_COLORS.text.error }} />
    </div>
  );
}

TemperatureBar.propTypes = { accepts: PropTypes.number, rejects: PropTypes.number };

export function SectorTemperature({ sectors = [], onResynth }) {
  return (
    <SectionRegenWrap title={copy.strategyInsights.sections.temperature} onResynth={onResynth}>
      {sectors.length === 0 ? (
        <p style={{ ...DS_TYPOGRAPHY.bodyMd, color: DS_COLORS.text.secondary, margin: 0 }}>
          {copy.strategyInsights.empty.temperature}
        </p>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: DS_SPACING.cardGap }}>
          {sectors.map((s) => (
            <div key={s.sector} data-regen-key={s.sector}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  marginBottom: DS_SPACING.labelToContent / 2,
                }}
              >
                <span style={{ ...DS_TYPOGRAPHY.listItemTitle, color: DS_COLORS.text.primary }}>
                  {s.sector}
                </span>
                <span style={{ ...DS_TYPOGRAPHY.sectionSubLabel, color: DS_COLORS.text.secondary }}>
                  {s.accepts + s.rejects}
                </span>
              </div>
              <TemperatureBar accepts={s.accepts} rejects={s.rejects} />
            </div>
          ))}
        </div>
      )}
    </SectionRegenWrap>
  );
}

SectorTemperature.propTypes = {
  sectors: PropTypes.array,
  onResynth: PropTypes.func,
};

export default SectorTemperature;
